import React, { useContext, useState, useEffect } from 'react';
import { Button } from 'primereact/button';
import { Toolbar } from 'primereact/toolbar';
import logo from '../images/logo_1.png';
import HeaderComponent from './HeaderComponent';
import '../styles/Home.css'
import TablaInventario from './TablaInventario';
import { apiService, setupInterceptors } from '../services/apiService';
import { AuthContext } from '../context/AuthContext';
import { Dropdown } from 'primereact/dropdown';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import PdfViewer from './PdfViewer';


const ListadoPreciosGenerados = () => {
    const { logoutUser } = useContext(AuthContext);

    const [ clientes, setClientes ] = useState([])
    const [ clienteSeleccionado, setClienteSeleccionado ] = useState(null)
    const [ presupuestosCliente, setPresupuestosCliente ] = useState([])

    const [showPdf, setShowPdf] = useState(false);
    const [ presupuestoPdfUrl, setPresupuestoPdfUrl] = useState(null);

    const handleShowPdf = (url_pdf) => {
        console.log(url_pdf)
        setPresupuestoPdfUrl(url_pdf);
        setShowPdf(true); // Mostrar el modal
    };
  
    const handleClosePdf = () => {
      setShowPdf(false); // Cerrar el modal
    };



    const getClientes = async () => {
        try {
            const response = await apiService.fetchData('clientes/');
            const clientesList = response.data.map(cliente => ({
                id: cliente.id,
                nombre: cliente.nombre,
                nombre_contacto: cliente.nombre_contacto
            }));
            setClientes(clientesList); 
        } catch (error) {
            console.error('Error al obtener datos:', error.response ? error.response.data : error.message);
        }
    };

    const getPresupuestosCliente = async () => {
        try {
            const response = await apiService.fetchData(`clientes/${clienteSeleccionado.id}/presupuestos_cliente/`);
            const presupuestosList = response.data.map(presupuesto => ({
                id: presupuesto.id,
                responsable: presupuesto.responsable,
                archivo_pdf_url: presupuesto.archivo_pdf_url,
                created_at: presupuesto.created_at,
            }));
            setPresupuestosCliente(presupuestosList)
            console.log(presupuestosCliente)
        } catch (error) {
            console.error('Error al obtener datos:', error.response ? error.response.data : error.message);
        }
    };

    useEffect(() => {
        // Configura el interceptor con la función de logout
        setupInterceptors(logoutUser);
        getClientes();
    }, [logoutUser]);

    useEffect(() => {
        // Configura el interceptor con la función de logout
        setupInterceptors(logoutUser);
        getPresupuestosCliente();
    }, [clienteSeleccionado]);

    const formatearMoneda = (value) => {
        return value.toLocaleString('es-AR', { style: 'currency', currency: 'ARS' });
    };

    return (
        <>
            <HeaderComponent title={"Listado Precios Generados"} />
            <div className='col-12 ml-6' style={{ minWidth:"95%", maxWidth:"95%" }}>

                <div style={{ display:"flex", flexDirection:"column", alignItems:"center" }}>
                    <h3 className='ml-2 mt-5'>Consulte Cliente</h3>
                    <div style={{ minWidth:"50%" }}>
                        <Dropdown
                            onChange={(e) => setClienteSeleccionado(e.value)}
                            value={clienteSeleccionado || null}
                            options={clientes}
                            filter
                            showClear
                            filterBy="nombre_contacto"
                            placeholder="Seleccione Cliente"
                            optionLabel="nombre_contacto"
                            style={{ width:"100%" }}
                        />
                    </div>
                </div>
                <div className='mt-4'>
                    <DataTable value={presupuestosCliente} responsiveLayout="scroll">
                        <Column field="id" header="Listado N°" style={{ textAlign: 'center', fontSize:"15px" }} alignHeader={"center"}
                        headerClassName='header-table-style' headerStyle={{ color:"#fff", border:"1px solid #F1F1F1", borderTopLeftRadius:"10px" }}
                        ></Column>
                        <Column field="created_at" header="Creado El" body={(data) => new Date(data.created_at).toLocaleString()} style={{ textAlign: 'center', fontSize:"15px" }} alignHeader={"center"}
                        headerClassName='header-table-style' headerStyle={{ color:"#fff", border:"1px solid #F1F1F1" }}
                        ></Column>
                        <Column field="responsable" header="Responsable" style={{ textAlign: 'center', fontSize:"15px" }} alignHeader={"center"}
                        headerClassName='header-table-style' headerStyle={{ color:"#fff", border:"1px solid #F1F1F1", borderTopLeftRadius:"10px" }}
                        ></Column>
                        <Column field="nombre" header="Acciones" style={{ textAlign: 'center', fontSize:"15px" }} alignHeader={"center"}
                        headerClassName='header-table-style' headerStyle={{ color:"#fff", border:"1px solid #F1F1F1" }}
                        body={(data) => (
                            <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
                                <Button label='Ver' size='small' icon='pi pi-eye'
                                onClick={() => window.open(`/listado_precios_detalle/${data.id}`, '_blank')} // Reemplaza con la ruta correcta
                                />
                                <Button 
                                label="Descargar" 
                                icon="pi pi-download" 
                                className="p-button-info" 
                                size="small"
                                onClick={() => handleShowPdf(data.archivo_pdf_url)}
                                />
                            </div>
                        )}

                        ></Column>
                    </DataTable>
                </div>
            </div>

            <PdfViewer
                show={showPdf}
                handleClose={handleClosePdf}
                title="Vista del PDF"
            >
                { presupuestoPdfUrl ?
                    <embed src={`${presupuestoPdfUrl}#zoom=75%`}
                        width="1100" height="750" type="application/pdf">
                    </embed>
                    :
                    <p className='text-center'><i>No se ha encontrado el archivo PDF</i></p>
                 }
            </PdfViewer>
        </>
    );
};

export default ListadoPreciosGenerados;
